// extracted by mini-css-extract-plugin
export default {"root":"DT3WEoqx","inner":"ntBQENVm","content":"tdpAHMyU","chart":"LiELAPt_","customPagination":"evj6Y2Ih","paginationPage":"Y4pI64Og","noData":"oHkkafxn"};